import {connect} from '@store/@common';
import {userHasFlag} from '@store/auth';

import {HasFlag} from './has-flag';

const mapStateToProps = {
  userHasFlag,
};

export default connect(HasFlag, mapStateToProps);
